import { render, staticRenderFns } from "./FieldRetireeProductVariants.vue?vue&type=template&id=2d936df8&scoped=true&"
import script from "./FieldRetireeProductVariants.vue?vue&type=script&lang=js&"
export * from "./FieldRetireeProductVariants.vue?vue&type=script&lang=js&"
import style0 from "./FieldRetireeProductVariants.vue?vue&type=style&index=0&id=2d936df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d936df8",
  null
  
)

export default component.exports